import React from 'react';

import * as classes from './ExecutiveSummaryTile.module.css';

const ExecutiveSummaryTile = ({
    label,
    children,
    isLoading,
    ...props
}) => {

    return (
        <div className={classes.Tile}>
            <div className={isLoading ? classes.TileBodyLoading : classes.TileBody}>
                {children}
            </div>
            {
                isLoading ?
                    null
                    :
                    <div>
                        {label}
                    </div>
            }
        </div>
    );
};

export default ExecutiveSummaryTile;
